module.exports = __webpack_public_path__ + "static/media/Musharna_gaussian2.c16745ac.png";